import * as React from 'react'

export default function displayName (
  wrapper: string,
  wrapped?: React.ComponentType<any>
) {
  const name = wrapped ? wrapped.displayName || wrapped.name || 'Unknown' : ''
  return `${wrapper}(${name})`
}
